import { ColorToken } from 'theme/colors/v2';
import { Theme, css } from '@emotion/react';
import { TypographyProps, Variant } from 'bento/Typography/Typography';

export const typographyBase =
  (mb: number, uppercase: boolean) =>
  ({ spacing }: Theme) => css`
    ${mb > 0 && `margin-bottom: ${spacing(mb)}px;`}
    ${uppercase && `text-transform: uppercase;`}
  `;

export const typographyColor =
  (color: NonNullable<TypographyProps['color']>) =>
  ({ colors }: Theme) => {
    if (color === 'inherit') {
      return css`
        color: inherit;
      `;
    }

    const tokenMap: Record<typeof color, ColorToken> = {
      default: 'fgDefault',
      subtle: 'fgSubtle',
      disabled: 'fgDisabled',
      contrast: 'fgContrast',
      primaryBase: 'fgPrimaryBase',
      primaryDark: 'fgPrimaryDark',
      successBase: 'fgSuccessBase',
      successDark: 'fgSuccessDark',
      warningBase: 'fgWarningBase',
      warningDark: 'fgWarningDark',
      dangerBase: 'fgDangerBase',
      dangerDark: 'fgDangerDark',
      internalBase: 'fgInternalBase',
      internalDark: 'fgInternalDark',
    };

    return css`
      color: ${colors[tokenMap[color]]};
    `;
  };

export const typographyVariant =
  (variant: Variant) =>
  ({ typography }: Theme) => {
    switch (variant) {
      case 'srOnly':
        return css`
          position: 'absolute';
          height: 1;
          width: 1;
          overflow: hidden;
        `;

      // TBD best value to return here
      case `inheritFont`:
        return undefined;

      default:
        return typography.variant(variant);
    }
  };
